// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UR_N","label":"styles_label__3qP3X"};